var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7283_39189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.566625 8.34788C0.199031 9.4995 -4.68667e-05 10.7264 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199078 14.5005 0.566672 15.6521L12 16.1739L23.4333 15.6522C23.8009 14.5005 24 13.2735 24 12C24 10.7264 23.8009 9.4995 23.4333 8.34783L12 7.82611L0.566625 8.34788Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4332 8.34786L11.9999 7.82614L0.5665 8.34786C0.457563 8.6893 0.363766 9.03744 0.285156 9.39134H23.7144C23.6359 9.03739 23.5421 8.6892 23.4332 8.34786Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2854 14.6086C0.363916 14.9625 0.457713 15.3106 0.56665 15.6521L0.567775 15.6521L11.9999 16.1738L23.4333 15.6521C23.5422 15.3107 23.636 14.9625 23.7146 14.6086H0.2854Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24C17.3538 24 21.888 20.4936 23.4333 15.6521H0.56665C2.11188 20.4935 6.6462 24 11.9999 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.10356e-05C6.6462 0.000107911 2.11198 3.5065 0.56665 8.34789L23.4333 8.34794C21.8881 3.50645 17.3539 1.41606e-05 12 6.10356e-05Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48376 4.95655C5.48376 3.83262 6.27365 2.89372 7.32848 2.66337C7.16638 2.62794 6.99815 2.60876 6.82537 2.60876C5.52871 2.60876 4.47754 3.65989 4.47754 4.95659C4.47754 6.2533 5.52862 7.30442 6.82537 7.30442C6.99815 7.30442 7.16634 7.2852 7.32848 7.24981C6.2737 7.01937 5.48376 6.08047 5.48376 4.95655Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71628 6.02374L8.87519 6.51288H9.3895L8.97344 6.81523L9.13234 7.30437L8.71628 7.00207L8.30012 7.30437L8.45908 6.81523L8.04297 6.51288H8.55728L8.71628 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3578 6.02374L10.5167 6.51288H11.0311L10.6149 6.81523L10.7739 7.30437L10.3578 7.00207L9.94168 7.30437L10.1006 6.81523L9.68457 6.51288H10.1988L10.3578 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 6.02374L12.1581 6.51288H12.6725L12.2564 6.81523L12.4153 7.30437L11.9992 7.00207L11.5831 7.30437L11.7421 6.81523L11.3259 6.51288H11.8403L11.9992 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6408 6.02374L13.7998 6.51288H14.3141L13.898 6.81523L14.057 7.30437L13.6408 7.00207L13.2247 7.30437L13.3837 6.81523L12.9675 6.51288H13.4818L13.6408 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 6.02374L15.4415 6.51288H15.9559L15.5398 6.81523L15.6987 7.30437L15.2826 7.00207L14.8665 7.30437L15.0254 6.81523L14.6094 6.51288H15.1236L15.2826 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3578 4.31622L10.5167 4.80532H11.0311L10.6149 5.10771L10.7739 5.5968L10.3578 5.2945L9.94168 5.5968L10.1006 5.10771L9.68457 4.80532H10.1988L10.3578 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 4.31622L12.1581 4.80532H12.6725L12.2564 5.10771L12.4153 5.5968L11.9992 5.2945L11.5831 5.5968L11.7421 5.10771L11.3259 4.80532H11.8403L11.9992 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6408 4.31622L13.7998 4.80532H14.3141L13.898 5.10771L14.057 5.5968L13.6408 5.2945L13.2247 5.5968L13.3837 5.10771L12.9675 4.80532H13.4818L13.6408 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 4.31622L15.4415 4.80532H15.9559L15.5398 5.10771L15.6987 5.5968L15.2826 5.2945L14.8665 5.5968L15.0254 5.10771L14.6094 4.80532H15.1236L15.2826 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 2.60867L12.1581 3.09786H12.6725L12.2564 3.40016L12.4153 3.88934L11.9992 3.58705L11.5831 3.88934L11.7421 3.40016L11.3259 3.09786H11.8403L11.9992 2.60867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6408 2.60867L13.7998 3.09786H14.3141L13.898 3.40016L14.057 3.88934L13.6408 3.58705L13.2247 3.88934L13.3837 3.40016L12.9675 3.09786H13.4818L13.6408 2.60867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 2.60867L15.4415 3.09786H15.9559L15.5398 3.40016L15.6987 3.88934L15.2826 3.58705L14.8665 3.88934L15.0254 3.40016L14.6094 3.09786H15.1236L15.2826 2.60867Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7283_39189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.11b857818318c24c01729536d69de1b8.svg";
export { ForwardRef as ReactComponent };